import React, { useState, useEffect } from "react";
import axios from "axios";
import PrescriptionHistory from "./PrescriptionHistory";
import Navbar from "./Navbar";
import { useNavigate, useLocation } from "react-router-dom";

const PrescriptionDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [prescriptions, setPrescriptions] = useState([]);
  const [filteredPrescriptions, setFilteredPrescriptions] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPrescriptions = async () => {
    const patient_id = location.state?.patient_id;
    if (!patient_id) {
      setError("Patient ID is missing.");
      setIsLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/prescriptions",
        JSON.stringify({ patient_id }),
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 && response.data.data) {
        setPrescriptions(response.data.data);
        setFilteredPrescriptions(response.data.data);
      } else {
        setError("No prescriptions found.");
      }
    } catch (err) {
      console.error("Error fetching prescriptions:", err);
      setError("Failed to fetch prescriptions. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPrescriptions();
  }, []);

  const handleBack = () => navigate(-1);

  const handleDateChange = (e) => {
    const date = e.target.value;
    setSelectedDate(date);
    if (!date) {
      setFilteredPrescriptions(prescriptions);
      return;
    }
    const filtered = prescriptions.filter((p) => p.date.startsWith(date));
    setFilteredPrescriptions(filtered);
  };

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-r from-blue-50 to-blue-100">
      <Navbar />
      {console.log(filteredPrescriptions)}

      {/* Top margin from Navbar */}
      <div className="mt-6 flex-grow px-4">
        <div className="w-full max-w-6xl mx-auto h-full">
          {isLoading ? (
            <div className="text-center text-gray-600">Loading prescriptions...</div>
          ) : error ? (
            <div className="text-center text-red-600">{error}</div>
          ) : (
           
            <PrescriptionHistory
              prescriptions={filteredPrescriptions}
              selectedDate={selectedDate}
              onDateChange={handleDateChange}
              onBackClick={handleBack}
            />
)}
        </div>
      </div>
    </div>
  );
};

export default PrescriptionDashboard;
